<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          sm="12"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <b-button
              variant="primary"
              :label="$t('Re-Trigger Webhook')"
              class="mr-1"
              @click="showModal('retrigger-webhook-filter')"
            >
              {{ $t('Re-trigger Webhook') }}
            </b-button>
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />

            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />

          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="productProfileRef"
      :items="webhookNotificationData"
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <template #cell(dateCreated)="data">
        {{ toDateWithYear(data.value) }}
      </template>
      <template #cell(notificationType)="data">
        {{ addSpaceToString(data.value) }}
      </template>
      <template #cell(errorResponse)="data">
        <div
          v-if="data.value"
          class="d-flex justify-content-center"
        >
          {{ `${data.value.slice(0, 6)}...` }}
          <feather-icon
            icon="CopyIcon"
            class="cursor-pointer ml-1"
            @click="onCopyItem(data.value)"
          />
        </div>
      </template>
      <template #cell(successResponse)="data">
        <div
          v-if="data.value"
          class="d-flex justify-content-center"
        >
          {{ `${data.value.slice(0, 6)}...` }}
          <feather-icon
            icon="CopyIcon"
            class="cursor-pointer ml-1"
            @click="onCopyItem(data.value)"
          />
        </div>
      </template>
      <template #cell(isSuccessful)="data">
        <b-badge
          pill
          :variant="getStatusColor(data.value === true ? 'Yes' : 'No')"
        >
          {{ data.value === true ? $t('Yes') : $t('No') }}
        </b-badge>
      </template>

      <!-- Column: Action -->
      <template #cell(actions)="data">
        <div class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            size="sm"
            @click="performResend(data.item)"
          >
            <span> {{ $t('Resend') }} </span>
          </b-button>
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer mr-2"
            @click="onSelectWebhookItem(data.item)"
          />
        </div>
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />
    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :ok-title="$t('Cancel')"
      ok-only
      ok-variant="outline-secondary"
      centered
      size="lg"
    >
      <div class="text-center">
        <p>{{ `Payload Reference: ${modalHeader.payloadReference}` }}</p>
        <p>{{ `Notification Type: ${addSpaceToString(modalHeader.notificationType)}` }}</p>
        <p>{{ `Date Created: ${modalHeader.dateCreated ? toDateWithYear(modalHeader.dateCreated) : ''}` }}</p>
        <p>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="ml-2"
            size="sm"
            @click="performCopyToClip()"
          >
            <feather-icon
              icon="CopyIcon"
              class="mr-25"
            />
            <span> {{ $t('Copy') }} </span>
          </b-button>
        </p>
      </div>

      <b-table
        ref="viewWebhookTable"
        :items="viewWebhooklList"
        :per-page="pageSize"
        :current-page="currentPage"
        fixed
        :fields="translatedViewWebhookTableHeaders"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
      >
        <template #cell(description)="data">
          {{ addSpaceToString(data.value) }}
        </template>

        <template #cell(oldValue)="data">
          <div v-if="Array.isArray(data.value)">
            <div
              v-for="(item, index) in data.value"
              :key="index"
            >
              <p
                v-for="([text, value], currentIndex) in Object.entries(item)"
                :key="currentIndex"
                class="text-danger"
              >
                <span>{{ text }}:  {{ value }}</span>
              </p>
            </div>
          </div>

          <b
            v-else
            :class="data.item.oldValue !== data.item.newValue ? 'text-danger break' : 'break'"
            style=""
          >{{ data.value }}</b>

        </template>

        <template #cell(newValue)="data">
          <div v-if="Array.isArray(data.value)">
            <div
              v-for="(item, index) in data.value"
              :key="index"
            >
              <p
                v-for="([text, value], currentIndex) in Object.entries(item)"
                :key="currentIndex"
                class="text-success"
              >
                <span>{{ text }}:  {{ value }}</span>
              </p>
            </div>
          </div>
          <b
            v-else
            :class="data.item.oldValue !== data.item.newValue ? 'text-success break' : 'break'"
          >{{ data.value }}</b>
        </template>
      </b-table>
    </b-modal>

    <!-- modal -->
    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="customFilterModal"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      centered
      size="lg"
      :title="$t('Filters')"
      hide-footer
      @hidden="resetFilters"
    >
      <b-row class="match-height">
        <!-- Payload Reference  -->
        <b-col md="6">
          <InputField
            id="payload-reference"
            v-model="filter.payloadReference"
            :label="$t('Payload Reference')"
            :placeholder="$t('Enter payload reference')"
            type="text"
          />
        </b-col>
        <!-- Payload Reference -->

        <!-- Notification Type -->
        <b-col md="6">
          <SelectField
            id="notification-type"
            v-model="filter.notificationType"
            :label="$t('Notification Type')"
            :placeholder="$t('Select product')"
            :reduce="option => option.value"
            :options="translatedNotificationTypeOptions"
            item="label"
          />
        </b-col>
        <!-- Notification Type -->

        <!-- Is Successful -->
        <b-col md="6">
          <SelectField
            id="is-successful"
            v-model="filter.isSuccessful"
            :label="$t('Is Successful')"
            :placeholder="$t('Select')"
            :reduce="option => option.value"
            :options="translatedIsSuccessfulOptions"
            item="label"
          />
        </b-col>
        <!-- Is Successful -->
      </b-row>
      <b-row>
        <!-- Start Date -->
        <b-col md="6">
          <DatePickerField
            id="start-date"
            v-model="filter.startDate"
            :min-date="new Date()"
            :label="$t('Start Date')"
            :config="datePickerConfig"
            :placeholder="$t('Start Date')"
          />
        </b-col>
        <!-- Start Date -->
        <!-- End Date -->
        <b-col md="6">
          <DatePickerField
            id="end-date"
            v-model="filter.endDate"
            :min-date="new Date()"
            :label="$t('End Date')"
            :config="datePickerConfig"
            :placeholder="$t('End Date')"
          />
        </b-col>
        <!-- End Date -->
      </b-row>
      <div class="w-100 d-flex justify-content-end mt-4 align-items-between">
        <div>
          <!-- <b-button
            variant="primary"
            :label="$t('Re-Trigger Webhook')"
            @click="showModal('retrigger-webhook-filter')"
          >
            {{ $t('Re-trigger Webhook') }}
          </b-button> -->
        </div>
        <div>
          <b-button
            variant="outline-secondary"
            class="mr-2"
            @click="$refs.customFilterModal.hide()"
          >
            {{ $t('Cancel') }}
          </b-button>
          <b-button
            variant="primary"

            @click="fetchWebhookNotification"
          >
            {{ $t('Apply') }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- Filter modal -->
    <!-- Re-trigger Webhook modal -->
    <b-modal
      id="retrigger-webhook-filter"
      ref="retriggerWebhookModal"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      centered
      size="sm"
      :title="$t('Re-trigger Webhook')"
      @hidden="resetRetriggerModal"
      @cancel="resetRetriggerModal"
    >
      <b-row>
        <b-col cols="12">
          <InputField
            id="retrigger-payload-reference"
            v-model="retrigger.postingsReference"
            :label="$t('Payload Reference')"
            :placeholder="$t('Enter Payload Reference')"
            type="text"
            rules="required"
            error-name="Payload Reference"
          />
        </b-col>
      </b-row>

      <template #modal-footer="{ hide }">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          :disabled="isLoading"
          @click="hide()"
        >
          {{ $t('Cancel') }}
        </b-button>
        <Button
          :label="$t('Send')"
          size="md"
          :loading="isLoading"
          :disabled="isLoading || !retrigger.postingsReference"
          @click="onRetriggerOk"
        />
      </template>
    </b-modal>
    <!-- Re-trigger Webhook modal -->

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BModal, BSpinner, BButton, BBadge,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
import { heightFade } from '@core/directives/animations'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import InputField from '../../../forms/InputField.vue'
import getStatusColor from '@/helpers/getStatusColor'
import addSpaceToString from '@/helpers/addSpaceToString'
import SelectField from '../../../forms/SelectField.vue'
import DatePickerField from '../../../forms/DatePickerField.vue'
import { toDateWithYear } from '@/helpers/formatDate'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Button from '../../../components/button/Button.vue'
import { eChannelsPermission } from '@/helpers/permissions'

const notificationTypeOptions = [
  { value: 'AccountCreated', label: 'Account Created' },
  { value: 'AccountUpdated', label: 'Account Updated' },
  { value: 'CustomerInfoCreated', label: 'Customer Info Created' },
  { value: 'CustomerInfoUpdated', label: 'Customer Info Updated' },
  { value: 'PostingsCompleted', label: 'Postings Completed' },
  { value: 'ReversalCompleted', label: 'Reversal Completed' },
]

const isSuccessfulOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
]

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    BTable,
    BSpinner,
    BModal,
    InputField,
    SelectField,
    TablePagination,
    Button,
    TableEntries,
    FullScreenSpinner,
    DatePickerField,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      addSpaceToString,
      getStatusColor,
      isReadonly: false,
      isDisabled: false,
      showSpinner: false,
      isBusy: false,
      sortBy: 'payloadReference',
      required,
      sortDesc: false,
      modalHeader: {
        payloadReference: '',
        notificationType: '',
        isSuccessful: '',
        dateCreated: '',
      },
      isLoading: false,
      retrigger: {
        sessionID: null,
        postingsReference: '',
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'payloadReference', sortable: true, label: 'Payload Reference' },
        { key: 'notificationType', sortable: true, label: 'Notification Type' },
        { key: 'bankCode', sortable: true, label: 'Bank Code' },
        { key: 'retries', sortable: true, label: 'Retries' },
        { key: 'isSuccessful', sortable: true, label: 'Is Successful' },
        { key: 'WebhookUrl', sortable: true, label: 'Webhook URL' },
        { key: 'errorResponse', sortable: true, label: 'Error Response' },
        { key: 'successResponse', sortable: true, label: 'Success Response' },
        { key: 'dateCreated', sortable: true, label: 'Date Created' },
        { key: 'actions', label: 'Actions' },
      ],
      filter: {
        payloadReference: '',
        notificationType: '',
        isSuccessful: null,
        startDate: null,
        endDate: null,
      },
      retriggerForm: {
        postingsReference: '',
        sessionID: null,
      },
      datePickerConfig: {
        dateFormat: 'Y-m-d',
      },
      // notificationTypeOptions: [
      //   { value: 'AccountCreated', label: 'Account Created' },
      //   { value: 'AccountUpdated', label: 'Account Updated' },
      //   { value: 'CustomerInfoCreated', label: 'Customer Info Created' },
      //   { value: 'CustomerInfoUpdated', label: 'Customer Info Updated' },
      //   { value: 'PostingsCompleted', label: 'Postings Completed' },
      //   { value: 'ReversalCompleted', label: 'Reversal Completed' },
      // ],
      viewWebhookTableHeaders: [
        {
          key: 'description', sortable: false, thStyle: { width: '40%' }, label: 'Description',
        },
        {
          key: 'value', sortable: false, thStyle: { width: '60%' }, label: 'Value',
        },
      ],
      // isSuccessfulOptions: [
      //   'Yes', 'No',
      // ],
      viewWebhooklList: [],
      webhookNotificationData: [],
    }
  },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedNotificationTypeOptions() {
      return notificationTypeOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    translatedViewWebhookTableHeaders() {
      return this.viewWebhookTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedIsSuccessfulOptions() {
      return isSuccessfulOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchWebhookNotification()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchWebhookNotification()
    },
  },
  mounted() {
    this.fetchWebhookNotification()
  },
  methods: {
    ...mapActions({
      getWebhookNotifications: 'eChannels/getWebhookNotifications',
      resendWebhook: 'eChannels/resendWebhookAction',
      getRetriggerWebhook: 'eChannels/getRetriggerWebhook',
    }),
    async fetchWebhookNotification() {
      this.isBusy = true
      this.hideModal('modal-filter')
      const filter = {
        ...this.filter,
        isSuccessful: { Yes: true, No: false }[this.filter.isSuccessful] ?? null,
      }
      try {
        const response = await this.getWebhookNotifications({
          search: filter,
          page: this.currentPage,
          limit: this.perPage,
          permission: eChannelsPermission.WEBHOOK_NOTIFICATION_REPORT,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.webhookNotificationData = data.data
        }
        this.totalCount = data.totalItems
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    onSelectWebhookItem(items) {
      this.modalHeader.payloadReference = items.payloadReference
      this.modalHeader.notificationType = items.notificationType
      this.modalHeader.isSuccessful = items.isSuccessful
      this.modalHeader.dateCreated = items.dateCreated

      const payload = JSON.parse(items.payload)
      this.viewWebhooklList = []
      // eslint-disable-next-line array-callback-return
      Object.entries(payload).reduce((accumulator, currentValue) => {
        const val = { description: currentValue[0], value: currentValue[1] }
        this.viewWebhooklList.push(val)
      }, [])

      this.$root.$emit('bv::show::modal', 'modal-lg')
    },
    performCopyToClip() {
      try {
        const jsonString = JSON.stringify(this.viewWebhooklList)
        navigator.clipboard.writeText(jsonString)
        this.alertSuccess({ text: this.$t('Copied to Clipboard') })
      } catch (error) {
        this.alertError({ text: this.$t('Error copying to clipboard:'), error })
      }
    },
    onCopyItem(item) {
      try {
        navigator.clipboard.writeText(item)
        this.alertSuccess({ text: this.$t('Copied to Clipboard') })
      } catch (error) {
        this.alertError({ text: this.$t('Error copying to clipboard:'), error })
      }
    },
    async performResend(item) {
      const { id, payloadReference } = item
      const checkWebhook = async () => {
        try {
          const formData = {
            id,
          }
          const response = await this.resendWebhook({
            formData,
            permission: eChannelsPermission.WEBHOOK_NOTIFICATION_REPORT,
          })
          const { status, data } = await response
          if (status === 200 && data.data) {
            const text1 = this.$t('Resending this webhook with Payload reference:')
            const text2 = this.$t('was successful')
            this.alertSuccess({ text: `${text1} ${payloadReference} ${text2}` })
            this.fetchWebhookNotification()
          }
        } catch (error) {
          const reasonText = this.$t('Your request to Resend Webhook failed. Reason:')
          error.response.data.errors.forEach(responseError => {
            this.alertError({ text: `${reasonText} ${responseError.errorMessage}` })
          })
        }
      }
      const payloadText = this.$t('Are you sure you want to resend this webhook with Payload reference:')
      this.confirm(checkWebhook, { title: '', text: `${payloadText} ${payloadReference}?` })
    },
    async fetchRetriggerModal() {
      this.isLoading = true
      try {
        const formData = {
          postingsReference: this.retrigger.postingsReference,
          sessionID: this.retrigger.sessionID,
        }

        const response = await this.getRetriggerWebhook({
          formData,
          permission: eChannelsPermission.WEBHOOK_NOTIFICATION_REPORT,
        })

        if (response.status === 200) {
          const text1 = this.$t('Payload reference:')
          const text2 = this.$t('exists and retrigger was successful.')

          this.alertSuccess({
            text: `${text1} ${this.retrigger.postingsReference} ${text2}`,
          })

          // CLOSE ONLY AFTER SUCCESS
          this.hideModal('retrigger-webhook-filter')

          // reset form
          this.retrigger.postingsReference = ''
          this.retrigger.sessionID = null
        }
      } catch (error) {
        const message = error?.response?.data?.message
      || error?.response?.data?.errors?.[0]?.errorMessage
      || 'Failed to retrigger webhook'

        this.alertError({ text: message })
      } finally {
        this.isLoading = false
      }
    },
    async onRetriggerOk() {
      await this.fetchRetriggerModal()
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchWebhookNotification()
    },
    resetModal() {
      this.isReadonly = false
      this.isLoading = false
    },
    resetRetriggerModal() {
      this.retrigger = { ...null }
    },

  },
}
</script>

<style scoped>
.button-right {
  text-align: right;
}
</style>
